// extracted by mini-css-extract-plugin
export default {"lettersWrapper":"WordAnimator_lettersWrapper__GGNad","letter":"WordAnimator_letter__gosxF"};